<template>
  <basic-dialog :show="show" @close="$emit('close')" max-width="800">
    <template v-slot:title>Supplier Commission Receipt</template>
    <v-row>
      <v-col sm="3">
        <date-picker
          customLabel="Payment Date"
          @onDateSelected="onDateSelected"
          :gtDateString="paymentDate"
          :outlined="outlinedInputs"
          hide-details
        ></date-picker>
      </v-col>
      <v-col>
        <v-text-field
          label="Amount"
          v-model.number="amount"
          :outlined="outlinedInputs"
          hide-details
        ></v-text-field>
      </v-col>
      <v-col>
        <payment-type-select
          v-model="paymentType"
          :outlined="outlinedInputs"
          hide-details
        ></payment-type-select>
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <v-text-field
          label="Reference"
          v-model.number="reference"
          :outlined="outlinedInputs"
          hide-details
        ></v-text-field>
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <v-textarea v-model="notes" label="Notes" :outlined="outlinedInputs" />
      </v-col>
    </v-row>
    <v-row v-if="debug">
      <v-col
        ><code>{{ paymentType }} - {{ isValid }}</code></v-col
      >
    </v-row>
    <template v-slot:actions>
      <v-btn color="primary" :disabled="!isValid" @click="onSave">Save</v-btn>
    </template>
  </basic-dialog>
</template>

<script>
import moment from "moment";
import BasicDialog from "../../shared/BasicDialog.vue";
import DatePicker from "../../shared/DatePicker.vue";
import PaymentTypeSelect from "../../shared/PaymentTypeSelect.vue";
export default {
  name: "supplier-commission-receipt-edit-dialog",

  props: {
    value: {
      type: Object,
      default: () => null,
    },
    show: {
      type: Boolean,
      default: () => false,
    },
  },

  components: { BasicDialog, PaymentTypeSelect, DatePicker },

  data() {
    return {
      debug: false,
      amount: this.value ? this.value.amount : 0,
      paymentDate: this.value
        ? this.value.paymentDate
        : new Date().toISOString(false),
      paymentType: this.value ? this.value.paymentType : "",
      notes: this.value ? this.value.notes : "",
      reference: this.value ? this.value.reference : "",
    };
  },

  computed: {
    outlinedInputs() {
      return this.$store.getters.localSettings("outlinedInputs");
    },
    isValid() {
      return Number(this.amount) != 0 && this.paymentType != "";
    },
  },

  watch: {
    value(newVal) {
      this.amount = newVal.amount;
      this.paymentDate = newVal.paymentDate;
      this.notes = newVal.notes;
      this.reference = newVal.reference;
    },
  },

  methods: {
    onDateSelected(payload) {
      this.paymentDate = payload;
    },
    onSave() {
      const input = {
        id: this.value ? this.value.id : undefined,
        amount: Number(this.amount),
        paymentType: this.paymentType,
        paymentDate: this.paymentDate,
        notes: this.notes,
        reference: this.reference,
      };
      this.$emit("input", input);
    },
  },
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/gt/finances/supplier-commission-receipts/SupplierCommissionReceiptEditDialog.vue